export const commissions = (state) => state.commissions;

export default {
  commissions,
};
